import React, { FC } from 'react';
import { selectCurrentUserSelectedLevel } from 'modules/authentication/state/selectors';
import { PermissionLevels } from 'common/constants/permissions';
import { getPermissionLevelRouteItems } from 'utils/route.utils';
import useRootSelector from 'common/hooks/useRootSelector';
import SidebarRoutes from 'components/Sidebar/SidebarRoutes';

const ClientPortalSidebarRoutes: FC = () => {
  const userLevel: PermissionLevels = useRootSelector(selectCurrentUserSelectedLevel);
  const levelSidebarItems = getPermissionLevelRouteItems(userLevel);

  return <SidebarRoutes routeItems={levelSidebarItems} />;
};

export default ClientPortalSidebarRoutes;
